import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { ConferenceMapBoothViewModel, ConferenceMapViewModel, SponsorshipProductViewModel } from 'src/app/_models/generatedModels';
import { CallForSponsorsService } from 'src/app/_services/generatedServices';
import { SponsorshipCartService } from 'src/app/_services/sponsorship-cart.service';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-booth-picker',
  templateUrl: 'booth-picker.component.html',
})
export class BoothPickerComponent implements OnInit {
  initialized = false;
  isMouseDown = false;
  startX = 0;
  startY = 0;
  currentScale = 0.7;
  @ViewChild('mapBox') mapBox: ElementRef;
  map: ConferenceMapViewModel;

  @Input() conferenceId: string;
  @Input() product: SponsorshipProductViewModel;
  @Input() readOnly = false;
  @Input() admin = false;
  selectedCount: number = 0;
  totalPrice: number = 0;
  selectedBooths: ConferenceMapBoothViewModel[];

  @Input() boothIdsFromCart: number[];

  constructor(private callForSponsorsService: CallForSponsorsService, private cartService: SponsorshipCartService, private toaster: ToasterService, private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.callForSponsorsService.getMapForConference(this.conferenceId).subscribe((map) => {
      this.map = map;
      console.log(this.currentScale);
      console.log(this.boothIdsFromCart);
      if (this.boothIdsFromCart && this.boothIdsFromCart.length > 0) {
        this.map.booths.forEach((booth) => {
          if (this.boothIdsFromCart.indexOf(booth.id) > -1) {
            booth.selected = true;
          }

          var override = Enumerable.from(booth.priceOverrides).firstOrDefault((x) => x.sponsorshipProductId == this.product?.id);

          if (!booth.product) {
            booth.product = this.product;
            booth.price = this.product?.price;
            booth.productName = this.product?.title;
          }

          console.log(override);
          if (booth.priceOverrides && override) {
            booth.price = Enumerable.from(booth.priceOverrides).first((x) => x.sponsorshipProductId == this.product.id).price;

            if (override.disabled == true) {
              booth.booked = true;
            }
          }


        });
        this.updatedSelectedStats();
      } else {
        this.map.booths.forEach((booth) => {
          var override = Enumerable.from(booth.priceOverrides).firstOrDefault((x) => x.sponsorshipProductId == this.product.id);

          console.log(override);
          if (!booth.product) {
            booth.product = this.product;
            booth.price = this.product.price;
            booth.productName = this.product.title;
          }

          if (booth.priceOverrides && override) {
            booth.price = Enumerable.from(booth.priceOverrides).first((x) => x.sponsorshipProductId == this.product.id).price;

            if (override.disabled == true) {
              booth.booked = true;
            }
          }


        });
      }

     // console.log('booked');
     // console.log(this.cartService.items);

      this.map.booths.forEach((b) => {
        //console.log(b.id);
        //console.log(b.product);

        b.booked = b.booked || Enumerable.from(this.cartService.items).any((x) => x.variationId == b.id && x.product != b.product);
      });

      //console.log(this.map.booths);
      // console.log(
      //   Enumerable.from(this.map.booths)
      //     .where((x) => x.selected)
      //     .toArray()
      // );

      this.initialized = true;
    });
  }

  mouseWheel(evt: WheelEvent) {
    console.log(evt);
    if (evt.deltaY > 0) {
      this.currentScale = this.currentScale - 0.02;
      this.updateTransform();
    }

    if (evt.deltaY < 0) {
      this.currentScale = this.currentScale + 0.02;
      this.updateTransform();
    }
    evt.preventDefault();
  }

  dragStarted(evt) {
    this.updateTransform();
  }

  cancel() {
    this.activeModal.dismiss();
  }

  addToCart() {
    this.cartService.clearByProduct(this.product);

    this.selectedBooths.forEach((booth) => {
      booth.product.price = booth.price;
      this.cartService.addItem(booth.product, booth.id, booth.name, 1, null);
    });

    console.log(this.cartService.items);
    this.activeModal.close();
  }

  update() {
    this.activeModal.close(this.selectedBooths);
  }

  updateTransform() {
    var transform = (<string>this.mapBox.nativeElement.style.transform).split('scale')[0];
    this.mapBox.nativeElement.style.transform = transform + 'scale(' + this.currentScale + ')';
  }

  selectBooth(booth: ConferenceMapBoothViewModel) {
    if (booth.booked && !this.admin) {
      return;
    }

    if (!this.admin && this.selectedCount == this.product.remainingQuantity && !booth.selected) {
      this.toaster.messageDialog('Maximum Quantity Exceeded', 'Error').subscribe();
      return;
    }

    booth.selected = !booth.selected;
    this.updatedSelectedStats();
  }

  updatedSelectedStats() {
    this.selectedBooths = Enumerable.from(this.map.booths)
      .where((x) => x.selected)
      .toArray();
    this.selectedCount = Enumerable.from(this.map.booths).count((x) => x.selected);
    this.totalPrice = Enumerable.from(this.map.booths)
      .where((x) => x.selected)
      .sum((x) => x.price);
  }
}
